"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDark = exports.useTheme = exports.useAppTheme = exports.ThemeProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const ThemePalettes_1 = require("./ThemePalettes");
const STORAGE_KEY = "themeMode";
const ThemeContext = (0, react_1.createContext)({
    isDark: false,
    colors: ThemePalettes_1.LightPalette,
    mode: "system",
    resolvedScheme: "light",
    setMode: async () => { },
});
const ThemeProvider = ({ children }) => {
    const systemScheme = (0, react_native_1.useColorScheme)();
    const [mode, setModeState] = (0, react_1.useState)("system");
    (0, react_1.useEffect)(() => {
        (async () => {
            const saved = await async_storage_1.default.getItem(STORAGE_KEY);
            if (saved === "light" || saved === "dark" || saved === "system")
                setModeState(saved);
        })();
    }, []);
    const resolvedScheme = mode === "system" ? (systemScheme === "dark" ? "dark" : "light") : mode;
    const colors = resolvedScheme === "dark" ? ThemePalettes_1.DarkPalette : ThemePalettes_1.LightPalette;
    const isDark = resolvedScheme === "dark";
    const setMode = async (newMode) => {
        const safe = newMode === "light" || newMode === "dark" || newMode === "system" ? newMode : "system";
        setModeState(safe);
        await async_storage_1.default.setItem(STORAGE_KEY, safe);
    };
    const value = (0, react_1.useMemo)(() => ({ isDark, colors, mode, resolvedScheme, setMode }), [isDark, colors, mode, resolvedScheme]);
    return (0, jsx_runtime_1.jsx)(ThemeContext.Provider, { value: value, children: children });
};
exports.ThemeProvider = ThemeProvider;
const useAppTheme = () => (0, react_1.useContext)(ThemeContext);
exports.useAppTheme = useAppTheme;
const useTheme = () => (0, exports.useAppTheme)().colors;
exports.useTheme = useTheme;
const useIsDark = () => (0, exports.useAppTheme)().isDark;
exports.useIsDark = useIsDark;
